module.exports = __webpack_public_path__ + "static/media/bg3_sm.757e84c3.webp";